var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTable2418(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6194 5.904L19.2726 0.421875C19.0616 0.15525 18.7401 0 18.4019 0H5.57584C5.23761 0 4.91612 0.15525 4.70514 0.421875L0.244495 6.04688C-0.023412 6.3855 -0.0758773 6.84787 0.110541 7.23825C0.295843 7.62637 0.686541 7.875 1.11519 7.875H2.23258V18H4.46514V7.875H6.6977V12.375H8.93025V7.875H15.0698V12.375H17.3023V7.875H19.5349V18H21.7674V7.875H22.8625C22.8703 7.875 22.877 7.875 22.8848 7.875C23.501 7.875 24 7.37213 24 6.75C24 6.4125 23.8527 6.10988 23.6194 5.904ZM19.517 5.625H17.2867H15.0564H8.92132H6.691H4.46068H3.43593L6.11277 2.25H17.8672L20.544 5.625H19.517Z",
    fill: "#FFCC3A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTable2418);
export default __webpack_public_path__ + "static/media/ico-table-24-18.4633531f.svg";
export { ForwardRef as ReactComponent };